module.exports = __webpack_public_path__ + "static/produto2-d37c56e0e06fa8e7ffb39f52468a5043.jpg";